import { render, staticRenderFns } from "./ApprovalInfoActions.vue?vue&type=template&id=6fb11e5c&scoped=true"
import script from "./ApprovalInfoActions.vue?vue&type=script&lang=js"
export * from "./ApprovalInfoActions.vue?vue&type=script&lang=js"
import style0 from "./ApprovalInfoActions.vue?vue&type=style&index=0&id=6fb11e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb11e5c",
  null
  
)

export default component.exports